import React from 'react';

interface MeterRangeProps {
  value: number;
  max?: number;
  className?: string;
  ariaLabel?: string;
  hint?: string;
}

/**
 * MeterRange - A visual meter bar with ticks and a label for score ranges.
 * @param value - The current value (0-100 by default)
 * @param max - The maximum value (default 100)
 * @param className - Optional className for the outer div
 * @param ariaLabel - Optional aria-label for accessibility
 * @param hint - Optional hint text to display below the meter
 *
 * Example usage:
 * <MeterRange value={75} max={100} ariaLabel='Score 75 of 100' hint='0–49: Poor • 50–74: Fair • 75–89: Good • 90–100: Excellent' />
 */
export const MeterRange: React.FC<MeterRangeProps> = ({
  value,
  max = 100,
  className = '',
  ariaLabel,
  hint,
}) => (
  <>
    <div
      className={`meter-range${className ? ' ' + className : ''}`}
      role='img'
      aria-label={ariaLabel || `Score ${value} of ${max}`}
    >
      <div
        className='meter-range-bar'
        style={{ '--val': `${(value / max) * 100}%` } as React.CSSProperties}
      ></div>
      <div className='meter-range-ticks' aria-hidden='true'></div>
    </div>
    {hint && <small className='hint'>{hint}</small>}
  </>
);

export default MeterRange;
